import { SelectedSort } from './selected-sort.model';
import { WidgetTagOptionType } from '../types/widget-tag-option-type';
import { SideListOptionType } from '../types/side-list-option-type';
import { guid } from '@fi-shared/utils/guid';

export class ObjectTagFilterParameter {
    Guid = guid();
    TagIds: number[] = [];
    Offset = 0;
    NumberOfRecordsToTake = 0;
    DisplayIcon = true;
    ShowOnlyNewsFeedItems = false;
    SelectedSort = new SelectedSort();
    ObjectId = 0;
    ObjectType;
    WidgetTagOptionType = WidgetTagOptionType.AnySelected;
    UseWidgetTagOptionType = true;
    FilterType = SideListOptionType.SharedWithMe;
    LoadDocuments: boolean;
    LoadMediaBankFiles: boolean;

    Initialize(
        tagIds: number[],
        offset: number,
        numberOfRecordsToTake: number,
        showOnlyNewsFeedItems: boolean,
        selectedSort: SelectedSort,
        displayIcon: boolean,
        widgetTagOptionType: WidgetTagOptionType,
        useWidgetTagOptionType: boolean,
    ) {
        this.TagIds = tagIds;
        this.ShowOnlyNewsFeedItems = showOnlyNewsFeedItems;
        this.Offset = offset;
        this.NumberOfRecordsToTake = numberOfRecordsToTake;
        this.DisplayIcon = displayIcon;
        this.WidgetTagOptionType = widgetTagOptionType;
        this.UseWidgetTagOptionType = useWidgetTagOptionType;

        if (selectedSort) {
            this.SelectedSort = selectedSort;
        }
    }
}
